// Dimension
export const FOOTER_HEIGHT = '3.2rem';
export const NAVBAR_HEIGHT = '3rem';
export const NAVBAR_COMPACT_HEIGHT = '2.5rem'

// Colours
export const COLOR_ONE = '#000000';
export const COLOR_TWO = '#14213D';
export const COLOR_THREE = '#FCA311';
export const COLOR_FOUR = '#E5E5E5';
export const COLOR_FIVE = '#FFFFFF';
export const PRIMARY = '#d212ac';
export const SECONDARY = '#00ffff';
export const PRIMARY_DISABLED = '#36454f';

export const REACT_APP_DEMO_PASS="-MKP,i6uWS^j'cuBu;cWP/X$M"
export const REACT_APP_DEMO_EMAIL="demo@debloat.us"
